import { Injectable } from '@angular/core';

import { Docorga } from '@docorga-v1/docorga-common';
@Injectable()
export class PubsubService extends Docorga.services.PubsubService {}
